import "core-js/modules/es.function.name.js";
export default function getUserInspectorLink(item) {
  if (!item.name && !item.id) {
    return null;
  }
  var search = item.id ? "id:".concat(item.id) : item.name;
  return "/users?search=".concat(encodeURIComponent(search));
}